import { render, staticRenderFns } from "./Navbarcreateoutline.vue?vue&type=template&id=65d2c8d4&"
import script from "./Navbarcreateoutline.vue?vue&type=script&lang=js&"
export * from "./Navbarcreateoutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports